<template lang="pug">
  hotsite-dcom
    .conteudo(style="height:auto;")
      .row
        .col-xs-12
          //- SOBRE
          bloco.-nomargin.-softpadding
            header(slot="header")
              titulo.-withbar.-upper Sobre a DCOM
              small.more: router-link(:to="{ name: 'DCOMSobre' }") Ver tudo
            .texto.dcom-sobre-inicial(slot="content" v-if='sobre', v-html="sobre")
            loading(slot="content" v-else)
      .row
        .col-xs-12
          //- DESTAQUE
          bloco.-nomargin.-softpadding
            header(slot="header")
              titulo.-upper
                i.fa.fa-check-square-o.fa-lg &nbsp;&nbsp;
                | Destaque
            .texto.dcom-sobre-inicial(slot="content" v-if='destaque', v-html="destaque")
            loading(slot="content" v-else)
      .row
        .col-xs-12
          //- ORIENTAÇÕES E MANUAIS
          bloco.-nomargin.-softpadding
            header(slot="header")
              titulo.-upper
                i.fa.fa-check-square-o.fa-lg &nbsp;&nbsp;
                | Orientações e Manuais
            .texto.dcom-sobre-inicial(slot="content" v-if='orientacoes', v-html="orientacoes")
            loading(slot="content" v-else)
      .row.faixa.margin
        //- .col-xs-12.col-sm-6
        //-   //- ATAS DE REGISTRO
        //-   bloco.-nomargin.-softpadding
        //-     header(slot="header")
        //-       titulo.-upper
        //-         i.fa.fa-file-text.fa-lg &nbsp;&nbsp;
        //-         | Atas de Registro
        //-       small.more: router-link(:to="{ name: 'DCOMAtas' }") Ver tudo
        //-     .texto(slot="content")
        //-       ul.lista
        //-         li.item: a(href="#").link Ata 01
        //-         li.item: a(href="#").link Ata 02
        //-         li.item: a(href="#").link Ata 03
        //-         li.item: a(href="#").link Ata 04
        .col-xs-12
          //- EDITAIS
          bloco.-nomargin.-softpadding
            header(slot="header")
              titulo.-upper
                i.fa.fa-graduation-cap.fa-lg &nbsp;&nbsp;
                | Editais
              small.more(v-if='editaisE.length > 0'): router-link(:to="{ name: 'DCOMEditais' }") Ver tudo
            loading(slot="content", v-if="loading")
            .texto.dcom-sobre-inicial(slot="content" v-if='editaisE.length > 0')
              ul.lista.dcom-editais-inicial
                .esq
                  li.item(v-for="edital in editaisE"): a(:href="edital.link" target="_blank" rel="noopener").link {{ edital.nome }}
                .dir
                  li.item(v-for="edital in editaisD"): a(:href="edital.link" target="_blank" rel="noopener").link {{ edital.nome }}
            mensagem.-warn(slot="content" v-else-if='editaisE.length == 0 && loading == false')
              p Nenhum edital foi encontrado no momento            
</template>

<style lang="scss">
.texto.dcom-sobre-inicial {
  li {
    color: $color-grey-dark !important;
  }
  p {
    img {
      max-width: 100%;
      height: 100%;
      border-radius: 7px;
      &.aligncenter {
        display: flex;
        margin: 0 auto;
        margin: 10px auto 10px auto;
      }
      &.alignleft,
      &.alignnone {
        margin: 10px 10px 10px 0;
      }
      &.alignright {
        display: flex;
        margin: 10px 0 10px auto;
      }
    }
  }
}

.lista.dcom-editais-inicial {
  display: flex;
  justify-content: space-between;
  @include media("<tablet") {
    flex-direction: column;
  }

  .esq,
  .dir {
    flex: 1;
  }
}

.margin {
  margin: 30px 0 40px 0;
}
</style>


<script>
  import Bloco from 'COMPONENTS/Bloco'
  import HotsiteDcom from 'PAGES/dcom/Base'
  import Listagem from 'COMPONENTS/BaseLista'
  import Loading from 'COMPONENTS/Loading'
  import Mensagem from 'COMPONENTS/Mensagem'
  import Titulo from 'COMPONENTS/ElementTitle'
  
  import ConteudoService from '../../../js/api/dcom/ConteudoService'
  import EditaisService from '../../../js/api/dcom/EditaisService'

  export default {
    components: {
      Bloco,
      HotsiteDcom,
      Listagem,
      Loading,
      Mensagem,
      Titulo
    },
    data () {
      return {
        sobre: '',
        destaque: '',
        orientacoes: '',
        editaisE: [],
        editaisD: [],
        loading: true
      }
    },
    mounted () {
      ConteudoService.getSobreInicial('dcom', 'sobre-a-dcom-inicial')
        .then(response => {
          this.sobre = response.data[0].acf.descricao
        })
      ConteudoService.getDestaqueAviso('dcom', 'destaque-aviso')
        .then(response => {
          this.destaque = response.data[0].acf.descricao
        })
      ConteudoService.getOrientacoesInicial('dcom', 'orientacoes-e-manuais-inicial')
        .then(response => {
          this.orientacoes = response.data[0].acf.descricao
        })
      EditaisService.getEditais('dcom', 'editais', 8, 1)
        .then(response => {
          this.editaisE = response.data.slice(0, 4).map(edital => {
            return { nome: edital.title.rendered, link: edital.acf.arquivo }
          })
          this.editaisD = response.data.slice(4, 8).map(edital => {
            return { nome: edital.title.rendered, link: edital.acf.arquivo }
          })
          this.loading = false
        })
    }
  }
</script>\



// WEBPACK FOOTER //
// Index.vue?29dfffb4